import { restore } from 'effector';
import { createRoute } from 'atomic-router';

import { getCurrentEmployeeFx } from 'shared/api';

export const $currentUser = restore(getCurrentEmployeeFx.doneData, null);

export const currentUserRoute = createRoute<{ id: number }>();
